export type MarketImpactType = (typeof MARKET_IMPACT_TYPES)[number];

export const MARKET_IMPACT_TYPES = ['new', 'used'] as const;

type MarketImpactDictionary<T> = {
  [key in MarketImpactType]: T;
};

export type MarketImpactServicesMode = MarketImpactDictionary<boolean>;

export type MarketImpactPermissions = MarketImpactDictionary<string>;

export type MarketImpactAvailableService = {
  type: MarketImpactType;
  isAvailable: boolean;
};

export const MARKET_IMPACT_PERMISSIONS: MarketImpactPermissions = {
  new: 'viewMarketImpactNew',
  used: 'viewMarketImpactUsed',
} as const;
